module.exports = __webpack_public_path__ + "static/media/icon-checking.5d233027.svg";